import {
    URLAPI,
    PRODUCT_PATH,
    PRODUCT_CREATE_PATH,
    PRODUCT_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_product: {
        data: [],

        status: 0,
        message: {},
    },

    _create_product: {
        data: {},
        status: 0,
        message: {},
    },
    _update_product: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_PRODUCT = "GET_ALL_PRODUCT";
export const CREATE_PRODUCT = "CREATE_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";

export const product_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_PRODUCT:
            return {
                ...state,
                _get_all_product: action.payload,
            };
        case CREATE_PRODUCT:
            return {
                ...state,
                _create_product: action.payload,
            };
        case UPDATE_PRODUCT:
            return {
                ...state,
                _update_product: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllProduct = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${PRODUCT_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_PRODUCT,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_PRODUCT,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_PRODUCT,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const createProduct = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${PRODUCT_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_PRODUCT,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_PRODUCT,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_PRODUCT,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateProduct = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${PRODUCT_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_PRODUCT,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_PRODUCT,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_PRODUCT,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_product = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
